module.exports = __webpack_public_path__ + "static/img/1.38dcb86.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatar/1.png
// module id = 6XdX
// module chunks = 1